import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const LOAD_IMPUTATIONS_BY_DAY = "LOAD_IMPUTATIONS_BY_DAY";
export const ADD_IMPUTATION = "ADD_IMPUTATION";
export const UPDATE_IMPUTATION = "UPDATE_IMPUTATION";
export const DELETE_IMPUTATION = "DELETE_IMPUTATION";
export const GET_IMPUTATIONS_BY_DAY = "GET_IMPUTATIONS_BY_DAY";

export const SET_ALL_IMPUTATIONS = "SET_ALL_IMPUTATIONS";
export const SET_CURRENT_OR_LAST_IMPUTATION = "SET_CURRENT_OR_LAST_IMPUTATION";

export const SET_INTERVENTIONS_FOR_IMPUTATIONS = "SET_INTERVENTIONS_FOR_IMPUTATIONS";

export const DEFAULT_CHECK_PERIOD_IN_MINUTES = 15;
